module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 function getStyle(styles) {
  return Object
    .keys(styles)
    .filter(function (k) {
      return styles[k]
    })
    .map(function (k) {
      var unit = ''
      if (['top', 'left', 'width', 'height'].indexOf(k) > -1) {
        unit = 'px'
      }
      return k + ':' + styles[k] + unit + ';'
    }).join('')
} ;
__p += '\n\n';
 function dateDiff(start, end) {
  start = new Date(start)
  var startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  if (!end) {
    end = new Date();
  }
  end = new Date(end)
  // need date in YYYY-MM-DD format
  var endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  if (startDate > endDate) {
    return null
  }

  var startYear = startDate.getFullYear();

  var yearDiff = endDate.getFullYear() - startYear;
  var monthDiff = endDate.getMonth() - startDate.getMonth();
  if (monthDiff < 0) {
    yearDiff--;
    monthDiff += 12;
  }
  var dayDiff = endDate.getDate() - startDate.getDate();
  if (dayDiff < 0) {
    if (monthDiff > 0) {
      monthDiff--;
    } else {
      yearDiff--;
      monthDiff = 11;
    }
    var year = endDate.getFullYear()
    var february = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28;
    var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var lastMonth = endDate.getMonth() - 1
    if (lastMonth < 0) {
      lastMonth = 11
    }
    dayDiff += daysInMonth[lastMonth];
  }

  var oneDay = 86400000
  if (endDate - startDate < oneDay * 100) {
    dayDiff = Math.ceil((endDate - startDate) / oneDay)
    dayDiff++
    if (dayDiff === 1) {
      return '出生啦'
    }
    if (dayDiff === 100) {
      return '100天啦'
    }
    return dayDiff + '天'
  }

  if (yearDiff > 0 && monthDiff === 0 && dayDiff === 0) {
    return yearDiff + '岁啦'
  }

  if (yearDiff > 0) {
    dayDiff = 0
  }

  return [
    yearDiff ? yearDiff + '岁' : '',
    monthDiff ? monthDiff + '个月' : '',
    dayDiff ? dayDiff + '天' : ''
  ].join('')
} ;
__p += '\n\n';
 function ifTextByChars(elements) {
  return JSON.stringify(elements).indexOf('"x":[') > -1
} ;
__p += '\n\n';
 var xOrigin = 48, yOrigin = 42 ;
__p += '\n\n';
 var texts = page.elements.filter(function (el) {
  return /text/.test(el.type)
}) ;
__p += '\n';
 var labels = page.elements.filter(function (el) {
  return /label/.test(el.type)
}) ;
__p += '\n';
 var images = page.elements.filter(function (el) {
  return /image|qrcode|video/.test(el.type)
}) ;
__p += '\n';
 var blocks = page.elements.filter(function (el) {
  return /block/.test(el.type)
}) ;
__p += '\n\n';
 if (images.length) { ;
__p += '\n  <div class="images">\n    ';
 images.forEach(function(element) { ;
__p += '\n      ';
 var src = element.src || element.content || '' ;
__p += '\n';
 var originalSrc = src ;
__p += '\n';
 var style = getStyle({
  top: element.y + yOrigin,
  left: element.x + xOrigin,
  width: element.w,
  height: element.h
}) ;
__p += '\n';
 var encode = function (str) {
  return btoa(unescape(encodeURIComponent(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
} ;
__p += '\n';
 var validSizes = [320, 480, 640, 800, 960, 1280] ;
__p += '\n';
 var size = validSizes.find(function (s) {
  return s >= element.w
}) || 640 ;
__p += '\n\n';
 if (element.type === 'video' && !element.video) {
  element.type = 'image'
} ;
__p += '\n';
 if (element.type === 'qrcode' && /^\/media/.test(src)) {
  element.type = 'image'
} ;
__p += '\n\n';
 if (element.type === 'image') { ;
__p += '\n  ';
 var isSelfHosted = /^\/(media|upload|fetch)|(img|static|cdn)\.xinshu\.me/.test(src) ;
__p += '\n  ';
 var suffix = '!' + (window.canUseWebp ? 'webp' : '') + size ;
__p += '\n  ';
 if (isSelfHosted) {
    src = src.split(/[#?!]/)[0].replace(/.*\/(upload|fetch)/, 'https://img.xinshu.me/$1') + suffix
  } else {
    src = 'https://media2.xinshu.me/fetch/' + encode(src) + suffix
  } ;
__p += '\n';
 } ;
__p += '\n\n';
 if (element.type === 'qrcode' && originalSrc && !/^\/(media|upload)/.test(originalSrc)) { ;
__p += '\n  ';
 src = 'https://canvas.xinshu.me/generate/wxbook-video?url=' +
    encodeURIComponent(originalSrc.split('#')[0]) ;
__p += '\n';
 } ;
__p += '\n\n';
 if (element.type === 'video') { ;
__p += '\n  ';
 src = 'https://canvas.xinshu.me/generate/wxbook-video-2?pic=' +
    encodeURIComponent(element.thumbnail)
    + '&qrcode=' + encodeURIComponent(element.video) ;
__p += '\n';
 } ;
__p += '\n';
 var classes = ['image', element.type].join(' ') ;
__p += '\n\n<div class="' +
((__t = ( classes )) == null ? '' : __t) +
'" data-msg-id="' +
((__t = ( element.msgId || element.pid )) == null ? '' : __t) +
'" style="' +
((__t = ( style )) == null ? '' : __t) +
'"\n     lazy-load="' +
((__t = ( src )) == null ? '' : __t) +
'"></div>\n\n    ';
 }) ;
__p += '\n  </div>\n';
 } ;
__p += '\n\n';
 if (labels.length) { ;
__p += '\n  <div class="labels">\n    ';
 labels.forEach(function(element) { ;
__p += '\n      ';
 var dateTime = new Date(element.content * 1000); ;
__p += '\n';
 var tzOffset = dateTime.getTimezoneOffset() ;
__p += '\n';
 dateTime = new Date(element.content * 1000 + (tzOffset + 480) * 60 * 1000) ;
__p += '\n';
 var style = getStyle({
  left: element.x + xOrigin,
  top: element.y + yOrigin
}) ;
__p += '\n<div class="label" style="' +
((__t = ( style )) == null ? '' : __t) +
'" data-msg-id="' +
((__t = ( element.msgId )) == null ? '' : __t) +
'">\n  ';
 var date = ('0' + dateTime.getDate()).slice(-2) ;
__p += '\n  ';
 var time = [('0' + dateTime.getHours()).slice(-2), ('0' + dateTime.getMinutes()).slice(-2)].join(':') ;
__p += '\n  <div class="date">' +
((__t = ( date )) == null ? '' : __t) +
'</div>\n  <div class="time">' +
((__t = ( time )) == null ? '' : __t) +
'</div>\n</div>\n\n    ';
 }) ;
__p += '\n  </div>\n';
 } ;
__p += '\n\n';
 if (texts.length) { ;
__p += '\n  <svg class="texts" style="left: ' +
((__t = ( xOrigin )) == null ? '' : __t) +
'px; top: ' +
((__t = ( yOrigin )) == null ? '' : __t) +
'px;">\n    ';
 xOrigin = 0; yOrigin = 0; ;
__p += '\n    ';
 blocks.forEach(function(element) { ;
__p += '\n      <rect data-msg-id="' +
((__t = ( element.msgId )) == null ? '' : __t) +
'" class="block"\n      x="' +
((__t = ( element.x )) == null ? '' : __t) +
'" y="' +
((__t = ( element.y )) == null ? '' : __t) +
'"\n      width="' +
((__t = ( element.w )) == null ? '' : __t) +
'" height="' +
((__t = ( element.h )) == null ? '' : __t) +
'"\n      fill="transparent"></rect>\n<path d="M ' +
((__t = ( element.x + element.w - 10 )) == null ? '' : __t) +
' ' +
((__t = ( element.y + 1 )) == null ? '' : __t) +
'\n               L ' +
((__t = ( element.x + element.w )) == null ? '' : __t) +
' ' +
((__t = ( element.y + 1 )) == null ? '' : __t) +
'\n               L ' +
((__t = ( element.x + element.w )) == null ? '' : __t) +
' ' +
((__t = ( element.y + 10 + 1 )) == null ? '' : __t) +
'" stroke="#aaa" stroke-width="2"\n      fill="transparent"></path>\n<path d="M ' +
((__t = ( element.x + element.w - 10 )) == null ? '' : __t) +
' ' +
((__t = ( element.y + element.h )) == null ? '' : __t) +
'\n              L ' +
((__t = ( element.x + element.w )) == null ? '' : __t) +
' ' +
((__t = ( element.y + element.h )) == null ? '' : __t) +
'\n              L ' +
((__t = ( element.x + element.w )) == null ? '' : __t) +
' ' +
((__t = ( element.y + element.h - 10 )) == null ? '' : __t) +
'" stroke="#aaa" stroke-width="2"\n      fill="transparent"></path>\n\n    ';
 }) ;
__p += '\n    ';
 texts.forEach(function(element) { ;
__p += '\n      ';
 element.content.forEach(function (line) { ;
__p += '\n  <g class="text" data-msg-id="' +
((__t = ( element.msgId )) == null ? '' : __t) +
'">\n    ';
 var chars = line.text ;
__p += '\n    ';
 for (var m = 0; m < chars.length; m++) { ;
__p += '\n      ';
 var x = xOrigin + line.x[m] ;
__p += '\n      ';
 var y = yOrigin + line.y ;
__p += '\n      ';
 if (line.emoji && line.emoji[m]) { ;
__p += '\n        ';
 var emoji = line.emoji[m] ;
__p += '\n        ';
 var isUrl = /^http/.test(emoji) ;
__p += '\n        ';
 emoji = isUrl ? emoji : 'https://static.weixinshu.com/assets/emotions/' + emoji ;
__p += '\n        <image xlink:href="' +
((__t = ( emoji )) == null ? '' : __t) +
'" width="18" height="18" x="' +
((__t = ( x )) == null ? '' : __t) +
'" y="' +
((__t = ( y )) == null ? '' : __t) +
'"/>\n      ';
 } else if (line.x[m] >= 0) { ;
__p += '\n        <text x="' +
((__t = ( x )) == null ? '' : __t) +
'" y="' +
((__t = ( y + 14 )) == null ? '' : __t) +
'">' +
((__t = ( chars[m] )) == null ? '' : __t) +
'</text>\n      ';
 } ;
__p += '\n    ';
 } ;
__p += '\n  </g>\n';
 }) ;
__p += '\n\n    ';
 }) ;
__p += '\n  </svg>\n';
 } ;
__p += '\n\n<footer>\n  <div class="pagination">' +
((__t = ( pageNo )) == null ? '' : __t) +
'</div>\n  <div class="book-title">' +
((__t = ( book.title )) == null ? '' : __t) +
'</div>\n  <div class="date">' +
((__t = ( year + '/' + month )) == null ? '' : __t) +
'</div>\n</footer>\n';

}
return __p
}